import React from "react"

import { NewSignInForm } from "../../components/NewSignInForm"

export const NewSignInPage = () => <NewSignInForm />
